import ExpandoPanel from './ExpandoPanel';

export default ExpandoPanel;